import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { LoadingPanelService, LoadingPanelSettings } from '../shared/loading-panel/loading-panel.service';

import { ChartConfiguration, BarCurveValue } from './models';
import { ChartService } from './services/chart.service';
import { ChartBase } from './chart-base';
import { DxResizableModule, DxChartModule } from 'devextreme-angular';

import { DxiSeriesModule, DxoCommonSeriesSettingsModule, DxoLegendModule, DxoSizeModule, DxoExportModule, DxoTooltipModule, DxoLoadingIndicatorModule } from 'devextreme-angular/ui/nested';

@Component({
    templateUrl: './chart-bar.component.html',
    selector: 'ep-chart-bar',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxResizableModule, DxChartModule, DxiSeriesModule, DxoCommonSeriesSettingsModule, DxoLegendModule, DxoSizeModule, DxoExportModule, DxoTooltipModule, DxoLoadingIndicatorModule]
})

export class ChartBarComponent extends ChartBase implements OnChanges {

    constructor(private router: Router, private loadingPanelService: LoadingPanelService, private chartService: ChartService) { super(); }

    @Input() chartConfiguration: ChartConfiguration;
    @Input() colorPalette: string;

    isLoading = false;
    series: any[] = [];
    values: any[] = [];

    ngOnChanges(changes: any) {
        if (changes.chartConfiguration && this.chartConfiguration) {
            this.loadData();
        }

        if (changes.colorPalette && Array.isArray(this.colorPalette)) {
            this.currentPalette = super.cleanColors(this.colorPalette);
        }
    }

    private loadData() {
        this.isLoading = true;
        this.chartService.getBarCurveValues(this.chartConfiguration.ChartConfigurationId).then(result => {
            this.initializeValues(result);
            this.isLoading = false;
        }).catch(() => { this.isLoading = false });
    }

    private initializeValues(valueFields: BarCurveValue[]) {
        // We need to group the objects, so the DevExpress component can understand it.
        valueFields.forEach(vf => {
            let value = this.values.find(v => v.GroupValue == vf.X2Value);

            if (!value) {
                value = { GroupValue: vf.X2Value };
                this.values.push(value);
            }

            value[vf.XValue] = vf.Value;

            let serie = this.series.find(s => s.Name == vf.XValue);
            if (!serie) {
                this.series.push({ Name: vf.XValue });
            }
        });
    }
}
